"use client";
import React from "react";
import Form from "../components/form";
import { PrismicNextImage } from "@prismicio/next";

const ContactForm = ({ slice, settings, noPadding = false }) => {
  return (
    <div className="">
      <PrismicNextImage
        field={slice?.primary?.contact_image}
        fallbackAlt=""
        className="w-full lg:max-w-[498px]"
      />
      <Form
        fields={settings?.data}
        title={settings?.data?.contact_form_title}
        button={settings?.data.contact_form_submit_button_label}
        noMobilePadding
        noPadding={noPadding}
      />
    </div>
  );
};

export default ContactForm;
